<template>
  <!-- && item.isShow === 1 && pcList && pcList.length > 0 -->
  <div v-if="item && list.length" class="mode2-box relative">
    <div
      class="relative new-mode-header"
      :class="titleAlignmentClass"
      v-if="item.topLanguageMap && item.topLanguageMap?.title && titleAlignment === 'TITLE_ALIGNMENT_CENTER'"
    >
      <div>
        <div class="title-left">
          <span class="title">{{ item.topLanguageMap?.title }}</span>
        </div>
        <!-- 副标题 -->
        <div class="title_sub" v-if="item.topLanguageMap?.subTitle">{{ item.topLanguageMap?.subTitle }}</div>
      </div>
    </div>
    <div v-if="list.length !== 0" class="relative mode4-header">
      <el-skeleton :loading="skeletonLoading" animated :throttle="0" v-if="titleAlignment === 'TITLE_ALIGNMENT_LEFT'">
        <template slot="template">
          <el-skeleton-item variant="text" style="width: 150px; height: 24px; margin-left: -35px" />
        </template>
        <div class="title-left">
          <img
            class="title-icon"
            v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.icon"
            :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.icon)"
            alt
          />
          <span class="title">{{ $utils.lang_data(lang, item.list[0] && item.list[0], "langInfoObj")?.title }}</span>
        </div>
      </el-skeleton>

      <i
        v-if="showType === 1"
        @click="cur_left > 0 ? changePosition('left') : ''"
        :class="cur_left > 0 ? '' : 'disabled'"
        class="icon-arrow-common el-icon-arrow-left custom"
      ></i>

      <i
        v-if="showType === 1"
        :class="cur_left < max_left - 1 ? '' : 'disabled'"
        @click="cur_left < max_left - 1 ? changePosition('right') : ''"
        class="icon-arrow-common el-icon-arrow-right custom"
      ></i>
    </div>
    <div v-if="showType === 1" class="hot-content" style="overflow: hidden">
      <div class="p-hot-box content" :class="`content_${content_index}`">
        <template v-for="(item, i) in list">
          <div
            class="img-box luckyMoudle"
            v-if="hidegd(item)"
            :key="'pc_' + i"
            :class="{ 'mr-0': (i + 1) % colNum === 0 }"
            :style="{ width: 96 / colNum + '%', marginRight: 4 / (colNum - 1) + '%' }"
          >
            <el-row :gutter="30">
              <el-col :span="11">
                <gameItem @play="reportClick" :item="item" :target="target" :key="'game_' + i" :skeletonLoading="skeletonLoading" />
              </el-col>
              <el-col :span="13">
                <div class="codeInfo">
                  <div>
                    <p class="codeTxt1">
                      <span class="fn16">X</span>&nbsp;
                      <span>{{ item.rewardMulti }}</span>
                    </p>
                    <p class="codeTxt">{{ $t("Datalang.newly_highest") }}</p>
                  </div>
                  <div>
                    <p class="codeTxt2">
                      <span>{{ divideAccuracy(Number(item.rewardAmount), useraccuracy) }}</span
                      >&nbsp;
                      <span class="c900">{{ userCoinCode }}</span>
                    </p>
                    <p class="codeTxt">{{ $t("Datalang.newly_winning") }}</p>
                  </div>
                  <div>
                    <p class="codeTxt3">{{ item.betCn }}</p>
                    <p class="codeTxt">{{ $t("Datalang.newly_betcount") }}</p>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="codeRank" :class="'type' + i">{{ i < 3 ? "" : i + 1 }}</div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="showType === 2 || showType === 3" class="hot-content">
      <div class="p-hot-box" :class="`content_${content_index}`">
        <template v-for="(item, i) in list">
          <div
            class="img-box"
            v-if="hidegd(item)"
            :key="'pc_' + i"
            :class="{ 'mr-0': (i + 1) % colNum === 0 }"
            :style="{ width: 90 / colNum + '%', marginRight: 10 / (colNum - 1) + '%' }"
          >
            <gameItem @play="reportClick" :item="item" :target="target" :key="'game_' + i" :skeletonLoading="skeletonLoading" />
          </div>
        </template>
        <div v-if="showType === 3 && isMore" class="more-btn-box">
          <div class="more-btn" @click="moreFun">{{ $t("Datalang.HomePage_BTM_loadmore") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mode4 from "@/lobby_common/mixins_views/homeModule/mode13.js";
export default {
  mixins: [mode4],
};
</script>
<style lang="scss" scoped>
.pl5 {
  padding-left: 5px;
}
.mode4-header {
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 15px;
  .title-left {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .title-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .mode-all {
    box-sizing: border-box;
    height: 30px;
    line-height: 28px;
    padding: 0 10px;
    cursor: pointer;
    color: var(--font-color-200);
    background: var(--button-1200);
    box-shadow: var(--boxShadow-1200);
    border-radius: var(--radius-200);
    transition: background ease 0.3s;
  }

  .mode-all:hover {
    background: var(--button-1201);
  }
}

.content {
  position: relative;
  display: flex;
  line-height: 0;
}

.el-icon-arrow-left.custom {
  width: 30px;
  position: absolute;
  right: 40px;
  top: 22px;
  cursor: pointer;
  z-index: 1;
  border-radius: var(--radius-200);
}

.el-icon-arrow-right.custom {
  width: 30px;
  position: absolute;
  right: 0px;
  top: 22px;
  cursor: pointer;
  z-index: 1;
  border-radius: var(--radius-200);
}

.hot-content {
  overflow: hidden;
  margin-top: 12px;
}
.p-hot-box.content {
  display: flex;
}
.p-hot-box {
  // overflow: hidden;
  position: relative;
  // display: flex;
  .img-box.luckyMoudle {
    // background: var(--background-1200);
    border-radius: var(--radius-300);
    padding: 15px 15px 2px 1px;
    background-position: top 0px right 0px;
    background-repeat: no-repeat;
    background-size: auto 100%;
    box-sizing: border-box;
    @media (max-width: 768px) {
      padding-top: 12px;
      border-radius: var(--radius-301);
    }
    &:nth-child(1) {
      background-image: url("~@/lobby_common/assets/homePage/bg1.png");
    }
    &:nth-child(2) {
      background-image: url("~@/lobby_common/assets/homePage/bg2.png");
    }
    &:nth-child(3) {
      background-image: url("~@/lobby_common/assets/homePage/bg3.png");
    }
    .codeInfo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 14vw;
      max-height: 210px;
      margin: 0px 0;
      p {
        line-height: 24px;
        margin: 0;
        padding: 0;
        width: 100%;
        overflow: hidden; /* 确保超出容器的文本被裁剪 */
        white-space: nowrap; /* 确保文本在一行内显示 */
        text-overflow: ellipsis;
      }
      .codeTxt {
        padding-top: 4px;
        color: var(--font-color-900);
      }
      .codeTxt1 {
        font-size: 24px;
        color: var(--font-color-1000);
        font-weight: bold;
        .fn16 {
          font-size: 16px;
        }
      }
      .codeTxt2 {
        font-size: 18px;
        color: var(--font-color-100);
        .c900 {
          color: var(--font-color-900);
        }
      }
      .codeTxt3 {
        font-size: 18px;
        color: var(--font-color-100);
      }
    }
    .codeRank {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 40px;
      position: absolute;
      top: 5px;
      right: 5px;
      color: var(--font-color-1100);
      background-image: url("~@/lobby_common/assets/homePage/rank4.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      &.type0 {
        background-image: url("~@/lobby_common/assets/homePage/rank1.png");
      }
      &.type1 {
        background-image: url("~@/lobby_common/assets/homePage/rank2.png");
      }
      &.type2 {
        background-image: url("~@/lobby_common/assets/homePage/rank3.png");
      }
    }
  }
  .img-box {
    position: relative;
    display: inline-block;
    width: 15%;
    // margin: 0 auto;
    padding-top: 24px;
    margin-right: 2%;
    cursor: pointer;
    transition: 0.5s;
    flex-shrink: 0;
    &.h5-box {
      width: 30%;
      margin-right: 4%;

      & > .txt {
        font-size: 14px;
        height: 42px;
        line-height: 42px;
      }

      &.more-box {
        position: relative;

        & > .txts {
          position: absolute;
          top: 35%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    &.mr-0 {
      margin-right: 0 !important;
    }

    &:last-child {
      margin-right: 0;
    }

    .txt {
      text-align: center;
      height: 36px;
      line-height: 36px;
    }

    .tubiao {
      position: absolute;
      right: 0px;
      width: 40px;
      height: 35px;
      top: 0px;
      box-sizing: border-box;
      z-index: 999;
    }
  }
}

.more-btn-box {
  width: 100%;
  padding: 10px 0;
  text-align: center;
  .more-btn {
    // width: 150px;
    display: inline-block;
    padding: 0 15px;
    height: 32px;
    line-height: 32px;
    background-color: var(--background-1400);
    margin: 0 auto;
    border-radius: var(--radius-200);
    margin-bottom: 16px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    color: var(--font-color-100);
  }
}
</style>
<style lang="scss">
.item-img-skeleton {
  position: relative;
  width: 100%;
  max-width: 300px;
  border-radius: var(--radius-300) !important;
  @media (max-width: 768px) {
    border-radius: var(--radius-301) !important;
  }
}
</style>
